export default __webpack_public_path__ + "static/media/blue3-big.c56112b7.png";